import React, { useEffect, useState, useCallback } from 'react';
import { ChartsDataDistribution, LimiaresParaOsGraficos } from '../../config/api/index.js';
import { getColorForLimiar, serieCampanhaColor, getPlotlyPlot, getAmostraTipos, getNomeLimiarSerieOuAmostraParaGraficoDeDistribuicao, getAxisType } from './ChartsUtils.js';
import ReactResizeDetector from 'react-resize-detector';

var state;
var cdfData;
var jsx = null;

const ScatterPlotly = (props) => {
    //Get localized reac-plotly plot
    const Plot = getPlotlyPlot();

    const [data, setData] = useState([]);
    const [limiares, setLimiares] = useState([]);
    const [axisType, setAxisType] = useState([]);
    const [siz, setSiz] = useState({});

    const [forceupdate, setForceUpdate] = useState({});

    const graph = (props) => {
        if (!state || forceupdate) {
            state = getNewPlot(props);
            setForceUpdate(false);
            jsx = null;
        }
        return getOldPlot(state);
    }

    function getNewPlot(props) {
        return (
            {
                data: [...data, ...limiares],
                layout: {
                    width: siz.width,
                    height: siz.height,
                    showlegend: true,
                    legend: {
                        orientation: 'h',
                        x: 1.02, y: 1,
                        bgcolor: '#eceeee'
                    },
                    margin: { l: 50, r: 10, b: 30, t: 10, pad: 4 },
                    xaxis: { type: axisType },
                    yaxis2: {
                        overlaying: 'y',
                        range: [0, 1],
                        showticklabels: false,
                        showgrid: false,
                        zeroline: false
                    },
                    xaxis2: {
                        showticklabels: false
                    },
                },
                config: {
                    locale: "pt-BR",
                    displaylogo: false,
                    displayModeBar: false,
                    modeBarButtonsToRemove: ['sendDataToCloud', 'hoverCompareCartesian', 'hoverClosestCartesian', 'lasso2d', 'select2d', 'autoScale2d']
                }
            }
        );
    }

    function getOldPlot(props) {
        if (!jsx) {
            jsx = (
                <Plot
                    data={state.data}
                    layout={state.layout}
                    config={state.config}
                />
            );
        }
        return jsx;
    }

    function cdf(arrayValores) {
        let cdf = {
            numberOfValues: arrayValores.length,
            values: [],
            getValuesAsArray: function () { return this.values.map(a => a.value); },
            getProbabilitiesAsArray: function () { return this.values.map(a => a.cumulativeProbability); }
        };

        arrayValores.sort((a, b) => a - b);
        let map = {};
        arrayValores.forEach(val => {
            const key = " " + val;
            if (key in map) map[key]++;
            else map[key] = 1;
        });

        let countedSoFar = 0;
        Object.keys(map).forEach(key => {
            let acumulated = map[key] + countedSoFar;
            const obj = {
                value: key.trim(),
                cumulativeProbability: (acumulated * 100) / cdf.numberOfValues
            };
            countedSoFar = acumulated;
            cdf.values.push(obj);
        });
        return cdf;
    }

    const setCDFData = useCallback(
        (parametro, data) => {
            if ((!cdfData) || cdfData.parametro !== parametro) {
                let dat = {};
                dat.parametro = parametro;
                data.series.forEach(el => {
                    dat[el.nomeSerie] = cdf(el.data);
                });
                cdfData = dat;
            }
        },
        [],
    )

    useEffect(() => {
        (async () => {
            if (!props.parametroSerie) return
            let dat = [];
            const data = await ChartsDataDistribution(props.parametroSerie.parametro, props.parametroSerie.seriesHabilitadas)
            setCDFData(props.parametroSerie.parametro, data);
            setAxisType(getAxisType(data));
            data.series.forEach(element => {
                const elementCDF = cdfData[element.nomeSerie];
                dat.push(
                    {
                        x: elementCDF.getValuesAsArray(),
                        y: elementCDF.getProbabilitiesAsArray(),
                        mode: 'markers',
                        type: 'scatter',
                        name: element.nomeSerie + ((element.unidade === null) ? ' ' : (' - (' + element.unidade + ')')),
                        marker: { color: serieCampanhaColor((element.nomeSerie)), size: 5 },
                        seriesid: element.idSerie
                    }
                );
            });
            setData(dat);
            setForceUpdate(true);
        })()
    }, [props.parametroSerie, setCDFData]);

    useEffect(() => {
        (async () => {
            if (!props.parametroSerie || !props.tipoLimiarSelecionado) return
            const tipoLimiarIds = props.tipoLimiarSelecionado.map(limiar => limiar.id);
            const tipoAmostraIds = getAmostraTipos();
            //get valores de limiares selecionados do servidor
            const lims = await LimiaresParaOsGraficos(props.parametroSerie.parametro, tipoAmostraIds, tipoLimiarIds)
            //calculate starting and ending Y
            let limiars = [];
            //load elementes to put into layout.shapes
            lims.forEach(element => {
                limiars.push(
                    {
                        mode: 'lines',
                        type: 'scatter',
                        name: getNomeLimiarSerieOuAmostraParaGraficoDeDistribuicao(element),
                        //hovertemplate: '%{x}',//NOT WORKING
                        //hoverinfo: 'x+name',//NOT WORKING
                        x: [element.valor, element.valor],
                        y: [0.08, 1],
                        yaxis: 'y2',
                        xaxis2: 'x2',
                        line: {
                            color: getColorForLimiar(element.tipo, element.superior),
                            width: 2,
                            dash: 'dot'
                        }
                    }
                );
            });
            setLimiares(limiars);
            setForceUpdate(true);
        })()
    }, [props.parametroSerie, props.tipoLimiarSelecionado])

    const onResize = (width, height) => {
        setSiz({ width: width, height: height });
        setForceUpdate(true);
    }

    return (
        <div style={{ position: "absolute", width: "98%", height: "94%" }}>
            {graph(props)}
            <ReactResizeDetector handleWidth handleHeight onResize={onResize} />
        </div>
    );

}

export default ScatterPlotly;